import React, { useEffect, useState } from "react";
import ContactUs from "../../Components/Popup/ContactUs";
import imagePath from "../../constants/imagePath";
import {
  AboutQuote,
  BorderImage,
  BorderImageAbout,
  MissionText,
  OurMission,
  OurVision,
  VisionText,
} from "../../constants/svgPath";
import gsap from "gsap";
// @ts-ignore
import ReactStars from "react-rating-stars-component";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import BannerAnimatedContent from "../../Components/BannerAnimatedContent";
function AboutUs() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const counters = document.querySelectorAll(".who_cont_list h3");

    // Sab counters ko initially 0 pe reset karo
    counters.forEach((counter) => {
      const el = counter as HTMLElement;
      const suffix = el.innerText.replace(/[0-9]/g, "");
      el.innerText = "0" + suffix;
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".aboutbg",
        start: "top 80%",
        end: "bottom 60%",
        scrub: false,
        markers: false,
      },
    });

    tl.from(".banner_left h1", {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
    })
      .from(
        ".banner_txt",
        {
          y: 30,
          opacity: 0,
          duration: 0.8,
          ease: "power2.out",
        },
        "-=0.5",
      )
      .from(
        ".btn_common",
        {
          scale: 0.8,
          opacity: 0,
          duration: 0.6,
          ease: "back.out(1.7)",
        },
        "-=0.3",
      )
      .from(
        ".cont_child",
        {
          y: 40,
          opacity: 0,
          stagger: 0.2,
          duration: 0.8,
          ease: "power2.out",
        },
        "-=0.4",
      );

    // ✅ Counter animation: all together
    const obj = { val: 0 }; // single object for animation
    tl.to(
      obj,
      {
        val: 1, // dummy value, we'll calculate individual counts in onUpdate
        duration: 2,
        ease: "power1.out",
        onUpdate: () => {
          counters.forEach((counter) => {
            const el = counter as HTMLElement;
            const finalValue = parseInt(
              el.dataset.value || el.innerText.replace(/[^\d]/g, ""),
            );
            const suffix = el.innerText.replace(/[0-9]/g, "");
            const progress = obj.val; // 0 → 1
            el.innerText = Math.floor(progress * finalValue) + suffix;
          });
        },
      },
      "-=0.3",
    ); // overlap with previous animation

    return () => {
      tl.kill();
    };
  }, []);

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("body_active");
    } else {
      document.body.classList.remove("body_active");
    }
  }, [isPopupOpen]);

  return (
    <>
      <section className="aboutbg">
        <div className="contair">
          <div className="banner_left">
            <BannerAnimatedContent />
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              Explore More
            </button>
          </div>
        </div>
      </section>
      <section className="who_sec">
        <div className="contair">
          <div className="who_flx">
            <div className="who_l">
              <div className="who_review_l">
                <div className="who_review">
                  <figure className="who_review_img">
                    <img src={imagePath.Who1} alt="" />
                    <img src={imagePath.Who2} alt="" />
                    <img src={imagePath.Who3} alt="" />
                    <img src={imagePath.Who4} alt="" />
                    <img src={imagePath.Who5} alt="" />
                  </figure>
                  <h3>28K Satisfied Clients</h3>
                  <div className="who_start">
                    <span className="who_nmber">4.8</span>
                    <ReactStars
                      count={5}
                      value={4}
                      size={32}
                      isHalf={true}
                      activeColor="#FFD700"
                      onChange={(newValue) =>
                        console.log("New rating is:", newValue)
                      }
                    />
                  </div>
                </div>
                <figure className="who_team">
                  <img src={imagePath.Whoteam} alt="" />
                </figure>
              </div>
              <figure className="who_girl">
                <img src={imagePath.Whogirl} alt="" />
              </figure>
            </div>
            <div className="who_r">
              <div className="heading">
                <h2>Who We Are?</h2>
                <p>
                  The project focused on designing and developing a
                  feature-rich, high-performance e-commerce mobile app for a
                  fashion retailer. It included a visually engaging product
                  catalog with advanced filters, secure multi-payment checkout,
                  and real-time inventory synchronization across online and
                  offline stores. Key features included personalized product
                  recommendations, dynamic push notifications for engagement,
                  and an intuitive admin dashboard for product management, sales
                  tracking, customer insights, and detailed analytics.
                </p>
              </div>
              <div className="client_btn">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(true)}
                  className="btn_common btn_primry"
                >
                  Explore Our Services
                </button>
              </div>
            </div>
          </div>
          <ul className="who_cont">
            <li className="who_cont_list">
              <h3 data-value="15">15+</h3>
              <p>Successful Client Engagements</p>
              <span>
                <BorderImageAbout />
              </span>
            </li>
            <li className="who_cont_list">
              <h3 data-value="5">5+ years</h3>
              <p>Experience Building Mobile & Web Solutions</p>
              <span>
                <BorderImageAbout />
              </span>
            </li>
            <li className="who_cont_list">
              <h3 data-value="50">100%</h3>
              <p>Commitment to Quality & On-Time Delivery</p>
              <span>
                <BorderImageAbout />
              </span>
            </li>
            <li className="who_cont_list">
              <h3 data-value="95">95%</h3>
              <p>Client Satisfaction</p>
            </li>
          </ul>
        </div>
      </section>
      <section className="guid_sec">
        <div className="contair">
          <div className="heading">
            <h2>Our Guiding Beliefs and Commitments.</h2>
          </div>
          <div className="guid_flx">
            <span>
              {" "}
              <AboutQuote />{" "}
            </span>
            <p>
              At Girips Technologies, we believe in crafting innovative digital
              solutions that empower businesses to connect, grow, and lead in
              the modern world. We’re dedicated to delivering custom IT
              solutions that go beyond current needs and anticipate future
              possibilities. From intelligent software development to seamless
              web and mobile experiences, our mission is to help businesses
              achieve lasting success through technology and innovation.
            </p>
            <figure>
              <img src={imagePath.Guiding} alt="" />
            </figure>
          </div>
        </div>
      </section>
      <section className="built_sec">
        <div className="contair">
          <div className="who_flx">
            <div className="built_l">
              <figure>
                <img src={imagePath.Built} alt="" />
              </figure>
            </div>
            <div className="who_r">
              <div className="heading">
                <h2>Built for Innovation. Designed for Impact.</h2>
                <p>
                  At Girips Technologies, we’re redefining how businesses
                  harness technology to grow. By combining creativity, technical
                  excellence, and strategic insight, we build smart, scalable,
                  and secure IT solutions that drive digital transformation with
                  clarity and confidence.
                </p>
                <p>
                  We drive digital transformation with clarity, helping
                  businesses streamline processes, enhance experiences, innovate
                  continuously, and achieve sustainable growth.
                </p>
              </div>
              <div className="client_btn">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(true)}
                  className="btn_common btn_primry"
                >
                  Hire Our Developer Now!
                </button>
              </div>
            </div>
          </div>
          <ul className="built_lst">
            <li className="built_bx">
              <OurMission />
              <h3>Our Mission</h3>
              <p>
                We simplify technology by creating innovative digital products,
                scalable systems, and seamless experiences, enabling businesses
                to grow efficiently and adapt rapidly.
              </p>
              <figure>
                <MissionText />
              </figure>
            </li>
            <li className="built_bx">
              <OurVision />
              <h3>Our Vision</h3>
              <p>
                Girips Technologies envisions empowering businesses with
                technology to innovate confidently, connect smartly, and grow
                sustainably, delivering value, trust, and impact digitally.
              </p>
              <figure>
                <VisionText />
              </figure>
            </li>
          </ul>
        </div>
      </section>
      <section className="emp_sec">
        <div className="contair emp_inner">
          <div className="emp_flx">
            <div className="emp_l">
              <div className="heading">
                <h2>
                  {" "}
                  <span> Empower Your Business </span>Partner with Girips
                  Technologies for Digital Excellence!
                </h2>
              </div>
              <div className="client_btn">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(true)}
                  className="btn_common btn_primry"
                >
                  Purchase Now & Start Your Journey!
                </button>
              </div>
            </div>
            <figure>
              <img src={imagePath.Empower} alt="" />
            </figure>
          </div>
        </div>
      </section>
      <section className="about_why_sec">
        <div className="contair why_inr">
          <div className="heading">
            <h2>Why Choose Us?</h2>
            <p>
              We combine innovation, expertise, and a client-first approach to
              deliver scalable digital solutions that drive real business
              growth.
            </p>
          </div>
          <ul className="about_why_lst">
            <li className="about_why_bx">
              <h3>Innovative Solutions</h3>
              <p>
                We solve complex business challenges with creative,
                technology-driven solutions that deliver measurable impact.
              </p>
              <figure>
                <img src={imagePath.Innovativesolutions} alt="" />
              </figure>
            </li>
            <li className="about_why_bx">
              <h3>Results-Driven Approach</h3>
              <p>
                We collaborate closely with clients to ensure every project
                exceeds expectations and achieves tangible outcomes.
              </p>
              <figure>
                <img src={imagePath.resultsDriven} alt="" />
              </figure>
            </li>
            <li className="about_why_bx">
              <h3>Trusted Growth Partner</h3>
              <p>
                With a proven track record and a client satisfaction rate above
                98%, we help businesses thrive sustainably.
              </p>
              <figure>
                <img src={imagePath.Trusted} alt="" />
              </figure>
            </li>
          </ul>
        </div>
      </section>
      <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default AboutUs;
